module.exports = __webpack_public_path__ + "img/booking_korporat.b63e0763.svg";